/**
 * Состав пака «pastel-serif» (WEB-3718) — смысл групп и источник каждого числа:
 * `../stylePackComposition.ts`. Файл на пак, общий список `./index.ts`
 * собирается по каталогу (решение владельца 23.10 ~04:35).
 */
import type { StylePackComposition } from '../stylePack.types';

export const composition: StylePackComposition = {
  // 10 воронок: паки/*.json, поле nearest (ближайший из 12 прежних паков)
  palettes: [
    // 4 из 10 воронок: palette → ближайшая тема по цветам
    { themeId: 'bento-brutalist', weight: 0.4 },
    // 2 из 10 воронок: palette → ближайшая тема по цветам
    { themeId: 'ink-premium', weight: 0.2 },
    // 2 из 10 воронок: palette → ближайшая тема по цветам
    { themeId: 'cream-editorial', weight: 0.2 },
  ],
  fonts: [
    // 8 из 10 воронок: fontId
    { fontId: 'inter', weight: 0.8 },
  ],
  screenKinds: [
    // средняя доля экранов по 10 воронкам (признаки.json kinds) 0.335; сюда свёрнуты Q6 (замена из arsenal.mjs)
    { kind: 'Q1', share: 0.36 },
    // средняя доля экранов по 10 воронкам (признаки.json kinds) 0.231
    { kind: 'I1', share: 0.25 },
    // средняя доля экранов по 10 воронкам (признаки.json kinds) 0.173
    { kind: 'Q2', share: 0.19 },
    // средняя доля экранов по 10 воронкам (признаки.json kinds) 0.100
    { kind: 'N7', share: 0.11 },
    // средняя доля экранов по 10 воронкам (признаки.json kinds) 0.051
    { kind: 'N1', share: 0.06 },
    // средняя доля экранов по 10 воронкам (признаки.json kinds) 0.036
    { kind: 'N4', share: 0.04 },
  ],
  blocks: [
    // в 6 из 10 воронок (признаки.json blocks), подъём 0.87; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): autoAdvance 77 из 115, optionIndicator 104 из 115
    {
      type: 'single_choice',
      weight: 0.6,
      settings: { autoAdvance: true, optionIndicator: 'none' },
    },
    // в 4 из 10 воронок (признаки.json blocks), подъём 0.89; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): optionIndicator 11 из 17, optionIndicatorStyle 11 из 17, optionIndicatorPosition 11 из 17
    {
      type: 'multiple_choice',
      weight: 0.4,
      settings: {
        optionIndicator: 'auto',
        optionIndicatorStyle: 'box',
        optionIndicatorPosition: 'left',
      },
    },
    // в 3 из 10 воронок (признаки.json blocks), подъём 1.96
    { type: 'height_picker', weight: 0.3, settings: {} },
    // в 3 из 10 воронок (признаки.json blocks), подъём 1.96
    { type: 'weight_picker', weight: 0.3, settings: {} },
  ],
  niches: [
    // 3 из 10 воронок (признаки.json theme)
    { niche: 'nutrition', weight: 0.3 },
    // 2 из 10 воронок (признаки.json theme)
    { niche: 'finance', weight: 0.2 },
  ],
};
